import React from 'react';
import DropTarget from './DropTarget';

const HoverZone = ({ connectDropTarget, direction }) =>
  connectDropTarget(<div className={`DNDScrollZone-${direction}`} />);

export default DropTarget(HoverZone);
